import React, { useState } from 'react';
import classNames from 'classnames';

import { AccordionItem } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const NodeFAQ = ({ entity, className }) => {
  const [collapsed, setCollapsed] = useState(true);

  const classes = classNames(className, 'FAQ');
  const iconClasses = classNames('icon', 'icon-variant-2', {
    'icon-plus': collapsed,
    'icon-minus': !collapsed,
  });

  const handleOnclick = () => {
    setCollapsed((prevCollapsed) => !prevCollapsed);
  };

  const question = entity.getIn(['title', 0, 'value']);
  const answer = entity.getIn(['body', 0, 'value']);

  return (
    <article className={classes} onClick={handleOnclick} itemScope itemType="https://schema.org/WebPage">
      <AccordionItem title={question} content={answer} iconClassName={iconClasses} />
    </article>
  );
};

export default NodeFAQ;
